import React from 'react';
import styled from 'styled-components';

const StyledPixel = styled.div`
  display: flex;
  flex-direction: column;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(255,255,255,0.8);
  margin: 2px;
  border-radius: 2px;
  &:hover {
    opacity: 0.9;
  }
`;

const StyledBit = styled.div`
  flex: 1;
  background: ${props => props.color};
`;

const Pixel = ({
  colors,
  onClick
}) => (
  <StyledPixel onClick={onClick}>
    {colors.map((color, i) => 
      <StyledBit key={i} color={color.background} />
    )}
  </StyledPixel>
)
export default Pixel;


// WEBPACK FOOTER //
// ./src/components/menu/palette-menu/pixel.js